/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getAreaByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetAreaById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getAreaByIdIdRegExpTwo)]).optional()
});

export type GetAreaById = zod.input<typeof GetAreaById>;
export type GetAreaByIdOutput = zod.output<typeof GetAreaById>;
